import { React, useState, useEffect, useContext } from "react";
import { AppContext } from '../../../../AppStore';
import axios from "axios";
import Swal from "sweetalert2";
import Button from "@mui/material/Button";
import Moment from 'moment';
import { useNavigate, useLocation } from "react-router-dom";

const MOB_Loss = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const appStore = useContext(AppContext);
    const [MenuID, setMenuID] = useState(0);
    const [MenuName, setMenuName] = useState('');
    const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState('N');
    const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState('N');
    const [MenuUpdateYN, setMenuUpdateYN] = useState('N');
    const [MenuDeleteYN, setMenuDeleteYN] = useState('N');
    const [selectKeyword, setSelectKeyword] = useState('');
    const [selectStartDate, setSelectStartDate] = useState(appStore.YYYY_MM_01());
    const [selectEndDate, setSelectEndDate] = useState(appStore.YYYY_MM_DD());
    const [originRows, setOriginRows] = useState([]);
    const [LossList, setLossList] = useState([]);

    useEffect(() => {
        appStore.setLoading(true);

        // 권한 설정은 주석 처리된 상태
        const fromSearch = location.state?.fromSearch;
        if (fromSearch) {
            setSelectStartDate(fromSearch.selectStartDate || '');
            setSelectEndDate(fromSearch.selectEndDate || '');
            setSelectKeyword(fromSearch.selectKeyword || '');
        }

        setTimeout(() => { // 초기 화면인 경우 늦게 표시 됨.
            const accessList = JSON.parse(localStorage.getItem("nav"));
            if (Array.isArray(accessList) && accessList.filter(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).length > 0) {
                setMenuID(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_id);
                setMenuName(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_name);
                setMenuUpdateExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_exist_yn);
                setMenuDeleteExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_exist_yn);
                setMenuUpdateYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_yn);
                setMenuDeleteYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_yn);
            } else {
                Swal.fire({
                    title: '<p style="color:red">접근 권한 오류</p>',
                    text: '화면에 접근 권한이 없습니다.',
                    confirmButtonText: '확인',
                    confirmButtonColor: '#7066e0',
                    timer: 5000,
                    timerProgressBar: true
                }).then((value) => {
                    return navigate(-1);
                });
            }
            appStore.setLoading(false);
        }, 800);

    }, []);

    useEffect(() => {
        if(String(MenuID) !== String(0) && MenuID != null){
            handleSearch();
        }
    }, [MenuID]);

    const handleSearch = () => {
        if (appStore.loading) return;
        appStore.setLoading(true);
        
        axios.get('/api/p/Loss/List',
            {
                params: {
                    search: selectKeyword
                }
            },
            { withCredentials: true }
        )
        .then((response) => {
            var array = response.data.map((item, index) => ({
                id: item.loss_id,
                loss_number: item.loss_number,
                loss_reason: item.loss_reason,
                loss_approval_user_id: item.loss_approval_user_id,
                loss_approval_user_name: item.loss_approval_user_name,
                reg_user_id: item.reg_user_id,
                reg_user_name: item.reg_user_name,
                recent_update_datetime: (item.update_datetime === undefined?Moment(item.reg_datetime).format('YYYY-MM-DD HH:mm:ss'):Moment(item.update_datetime).format('YYYY-MM-DD HH:mm:ss')),
            }));
            setOriginRows(response.data);
            setLossList([ ...new Set((array).map(JSON.stringify)) ].map(JSON.parse));
        })
        .catch((error) => {
            appStore.capture();
        })
        .finally(() => {
            appStore.setLoading(false); 
        });
    };

    const handleRowClick = (loss_id) => {
        navigate(`/m/loss_detail/${loss_id}`, {
            state: {
                fromSearch: {
                    originRows: originRows.filter((originRows) => originRows.loss_id === loss_id),
                    selectStartDate: selectStartDate,
                    selectEndDate: selectEndDate,
                    selectKeyword: selectKeyword
                }
            }
        });
    };

    return (
        <div style={{ width: '100%', display: String(MenuID) === String(0) ? 'hidden' : 'block' }}>
            <div className="M_menubox">
                <div className="menu-action">
                    <div className="menu-title">분실정보</div>
                    <div style={{ float: 'right' }}>
                        <Button
                            onClick={handleSearch}
                            className="M_btn-p"
                            sx={{
                                m: 1,
                                fontSize: 15,
                                color: "white",
                                bLossColor: "#3D63AE",
                                backgroundColor: "#3D63AE",
                                ":hover": { boxShadow: "2px 2px 2px #3D63AE" , backgroundColor: "#3D63AE", borderColor: "#3D63AE"}
                            }}
                            variant="outlined">
                            조회
                        </Button>
                    </div>
                </div>
            </div>

            <div className="M_contents">
                <div style={{ overflow: 'hidden' }}>
                    <div className="M_menu-keyword-sub-keyword" style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px',
                        }}>
                        <input
                            type="date"
                            value={selectStartDate}
                            onChange={(e) => setSelectStartDate(e.target.value)}
                            style={{ flex: 1 }}
                        />
                        <span style={{ color: '#999' }}>~</span>
                        <input
                            type="date"
                            value={selectEndDate}
                            onChange={(e) => setSelectEndDate(e.target.value)}
                            style={{ flex: 1 }}
                        />
                        </div>
                    
                    <div className="M_menu-keyword-sub-keyword" style={{ width: '100%' }}>
                        <input
                        type="text"
                        placeholder="검색"
                        value={selectKeyword}
                        onChange={(e) => setSelectKeyword(e.target.value)}
                        style={{ width: '100%' }}
                        />
                    </div>
                </div>

                <div>
                    {LossList.length === 0 ? (
                        <p style={{ textAlign: 'center', color: '#aaa' }}>분실정보가 없습니다.</p>
                    ) : (
                        LossList.map((Loss) => (
                        <div
                            key={Loss.id}
                            onClick={() => handleRowClick(Loss.id)}
                            style={{
                            backgroundColor: '#fff',
                            bLossBottom: '1px solid #eee',
                            padding: '7px 8px',
                            fontSize: '14px'
                            }}
                        >
                            {/* ✅ 1줄: 분실번호 + 분실명 */}
                            <div style={{
                            fontWeight: 'bold',
                            fontSize: '16px',
                            color: '#222',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                            }}>
                            {Loss.loss_number} / 승인자 : {Loss.loss_approval_user_name?.trim() ? Loss.loss_approval_user_name : '-'}
                            </div>

                            {/* ✅ 2줄: 분실사유 */}
                            <div style={{
                            fontSize: '15px',
                            color: '#444',
                            marginTop: '4px', 
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                            }}>
                            {Loss.loss_reason}
                            </div>

                            {/* ✅ 3줄: 수정자 | 일시 + 분실상태 */}
                            <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginTop: '4px'  // 간격 통일
                            }}>
                            <div style={{ fontSize: '13px', color: '#888' }}>
                                {Loss.reg_user_name} | {Loss.recent_update_datetime}
                            </div>
                            </div>
                        </div>
                        ))
                    )}
                    </div>
            </div>
        </div>
    );
};

export default MOB_Loss;